import axios from "axios";
import store from "../stories/store";
import { setActorsResults, setSendEmailToken, setErrorMessage } from "../stories/actions";
import { getSendEmail } from "./sendgridservice";
import { v4 as uuidv4 } from "uuid";
import * as roomRTC from "./roomRTC";

export const headers = {
    "Accept": "application/json",
    "Content-Type": "application/json",
    "x-api-key": "17&*up#od@f$dwqrg+iji8b(9l88b+067fnui@!o&q-&krp8j2"
};

const apiCreate = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers
});

const SERVER_API = process.env.REACT_APP_API_URL;
const SERVER_APP = process.env.REACT_APP_APP_URL;

export const getSessionConnecteds = async (sessionId) => {
    const response = await axios.get(`${SERVER_API}/user-exists/${sessionId}`);
    return response.data;
};

export const getIsRoomExists = async (roomId) => {
    const response = await axios.get(`${SERVER_API}/room-exists/${roomId}`);
    return response.data;
};

export const getIsRoomListeners = async (roomId) => {
    const response = await axios.get(`${SERVER_API}/room-listener/${roomId}`);
    return response.data;
};

export const getTurnCredentials = async () => {
    const response = await axios.get(`${SERVER_API}/get-turn-credentials`);
    return response.data;
};

export const getCreateConnections = async (usuarioId, token, ativo) => {
    const conectionSchema = {
        usuarioId,
        token,
        ativo
    };

    await apiCreate.post(`${SERVER_API}/connection-create`, conectionSchema).then(res => {
        if (res.status === 201) {
            console.log("Session create successful");
        }
    });
};

export const getUpdateConnection = async (id, token, ativo) => {
    const conectionSchema = {
        token,
        ativo
    };

    await apiCreate.patch(`${SERVER_API}/connection-update/${id}`, conectionSchema).then(res => {
        if (res.status === 200) { }
    }).catch(error => {
        console.error(error);
    });
};

export const getCreateTokensExpire = async (token) => {
    const tokensExpireSchema = {
        token: token
    };

    await apiCreate.post(`${SERVER_API}/tokens-expire-create`, tokensExpireSchema).then(res => {
        if (res.status === 201) {
            console.log("Tokens expire create successful");
        }
    });
};

export const getCreateUserEmailAndPassword = async (name, email, phone, passwd, active) => {
    const uid = uuidv4();

    const userSchema = {
        token: uid,
        nome: name,
        email: email,
        telefone: phone,
        senha: passwd,
        ativo: active
    };

    const mailTo = email;
    const subject = "Avance Revalida";
    const text = "Obrigado por se cadastrar no Avance Revalida";
    const html = `<h4>Obrigado por se cadastrar no Avance Revalida</h4>
    <p>Parabéns! Agora você pode acessar o sistema com sucesso. Explore todas as funcionalidades disponíveis e aproveite ao máximo nossa plataforma.</p>
    <p>Se precisar de ajuda, entre em contato conosco.</p>`;

    await apiCreate.post(`${SERVER_API}/user-create`, userSchema).then(res => {
        if (res.status === 201) {
            getSendEmail(mailTo, subject, text, html);

            store.dispatch(setErrorMessage("O registro do usuário foi concluído com sucesso. Agora ele pode fazer login com as credenciais cadastradas."));
        }
    }).catch(error => {
        console.error(error);
    });
};

export const getUserAdminTokenUpdate = async (id) => {
    const userSchema = {
        token: uuidv4()
    };

    await apiCreate.patch(`${SERVER_API}/user-update/${id}`, userSchema).then(res => {
        if (res.status === 200) {
            console.log("Send mail successful");
        }
    }).catch(error => {
        console.error(error);
    });
};

export const getSendPasswordResetEmail = async (user) => {
    const url = `${SERVER_APP}/?page-register=true&sendToken=${user.token}`;
    const mailTo = user.email;
    const subject = "Avance Revalida";
    const text = "Você fez um pedido para alterar a sua senha. Se não fez essa solicitação desconsidere este email";
    const html = `<h4>Redefinição de Senha</h4>
    <p>Recebemos um pedido para alterar a sua senha. Se você não solicitou essa alteração, por favor, desconsidere este e-mail.</p>
    <span>Redefinir agora: <a href="${url}">Clique aqui</a></span>`;

    try {
        await getSendEmail(mailTo, subject, text, html);
        await getCreateTokensExpire(user.token);

        store.dispatch(setSendEmailToken(user.token));
        store.dispatch(setErrorMessage("Por favor, verifique seu email"));
    } catch (error) {
        store.dispatch(setSendEmailToken(null));
        store.dispatch(setErrorMessage("Ops! por favor tente novamente."));
    }
};

export const getConfirmePasswordResetEmail = async (user, passwd) => {
    const userSchema = {
        senha: passwd
    };

    await apiCreate.patch(`${SERVER_API}/user-update/${user._id}`, userSchema).then(res => {
        if (res.status === 200) {
            console.log("Send mail successful");
        }
    }).catch(error => {
        console.error(error);
    });
};

export const getUserAccessUpdate = async (id, ativo) => {
    const userSchema = {
        ativo
    };

    await apiCreate.patch(`${SERVER_API}/user-update/${id}`, userSchema).then(res => {
        if (res.status === 200) { }
    }).catch(error => {
        console.error(error);
    });
};

export const getUserSignOut = (data) => {
    roomRTC.removeSessionPeerConnection(data);
    roomRTC.removeRoomPeerConnection(data);

    window.location.href = window.location.origin;
};

export const getAreasModel = async (setAreaCard) => {
    try {
        const response = await fetch(`${SERVER_API}/area-search`, { headers });

        if (!response.ok) {
            throw new Error(`Erro na requisição: ${response.status}`);
        }

        const data = await response.json();
        setAreaCard(data.data.model);
    } catch (error) {
        console.error("Erro ao buscar áreas:", error);
    }
};

export const getStationModel = async (setStations) => {
    try {
        const response = await fetch(`${SERVER_API}/station-search`, { headers });
        if (!response.ok) {
            throw new Error(`Erro na requisição: ${response.status}`);
        }

        const data = await response.json();
        setStations(data.data.model);
    } catch (error) {
        console.error("Erro ao buscar estação:", error);
    }
};

export const getTaskModel = async (setTaskCard) => {
    try {
        const response = await fetch(`${SERVER_API}/task-search`, { headers });
        if (!response.ok) {
            throw new Error(`Erro na requisição: ${response.status}`);
        }

        const data = await response.json();
        setTaskCard(data.data.model);
    } catch (error) {
        console.error("Erro ao buscar tarefas:", error);
    }
};

export const getQuestionModel = async (setQuestionCard) => {
    try {
        const response = await fetch(`${SERVER_API}/question-search`, { headers });
        if (!response.ok) {
            throw new Error(`Erro na requisição: ${response.status}`);
        }

        const data = await response.json();
        setQuestionCard(data.data.model);
    } catch (error) {
        console.error("Erro ao buscar perguntas:", error);
    }
};

export const getDatasetModel = async (id, setDataset) => {
    try {
        const response = await fetch(`${SERVER_API}/notes-logs-actors-search/${id}`, { headers });
        if (!response.ok) {
            throw new Error(`Erro na requisição: ${response.status}`);
        }

        const data = await response.json();
        setDataset(data.data.model);
    } catch (error) {
        console.error("Erro ao buscar perguntas:", error);
    }
};

export const saveActorsResults = async (usuarioId, ator, avaliador, area, estacao, nota, areaId, estacaoId) => {
    const resultSchema = {
        usuarioId,
        ator,
        avaliador,
        area,
        estacao,
        nota,
        areaId,
        estacaoId
    };

    await apiCreate.post(`${SERVER_API}/notes-actors-create`, resultSchema).then(res => {
        if (res.status >= 200 && res.status < 300) {
            console.warn("Resultados adicionados com sucesso!");
        }
    }).catch(error => {
        console.error(error);
    });
};

export const allActorsResults = async () => {
    try {
        const response = await fetch(`${SERVER_API}/notes-actors-search`, { headers });

        if (!response.ok) {
            throw new Error(`Erro na requisição: ${response.status}`);
        }

        const data = await response.json();

        store.dispatch(setActorsResults(data.data.model));
    } catch (error) {
        console.error("Erro ao buscar usuários:", error);
    }
};

const saveNotesLogs = async (usuarioId, ator, avaliador, area, estacao, nota, areaId, estacaoId, mensagem) => {
    const resultSchema = {
        usuarioId,
        ator,
        avaliador,
        area,
        estacao,
        nota,
        areaId,
        estacaoId,
        mensagem
    };

    try {
        const response = await apiCreate.post(`${SERVER_API}/notes-logs-actors-create`, resultSchema);

        if (response.status >= 200 && response.status < 300) {
            return { success: true, data: response.data };
        } else {
            return { success: false, status: response.status };
        }
    } catch (error) {
        return { success: false, error: error.message };
    }
};

export const isRoomExists = async (roomId) => {
    const response = await fetch(`${SERVER_API}/room-search`, { headers });

    if (!response.ok) {
        console.error("Erro ao buscar sala");
    }

    const data = await response.json();
    const rooms = Array.isArray(data.data.model) ? data.data.model : [];

    return rooms.find((room) => room.roomId === roomId);
};

export const saveRoom = async (roomId, identity, usuarioId, isRoomHost, avatar, isCheckListener) => {
    const resultSchema = {
        roomId,
        identity,
        usuarioId,
        isRoomHost,
        avatar,
        isCheckListener
    };

    try {
        const response = await apiCreate.post(`${SERVER_API}/room-create`, resultSchema);

        if (response.status >= 200 && response.status < 300) {
            console.warn("Sala criada com sucesso");
        } else {
            console.warn("Resposta inesperada ao criar sala:", response.status);
        }
    } catch (error) {
        console.error("Erro ao criar sala:", error);
    }
};

export const getRoomListener = async (roomId, identity, usuarioId, isRoomHost, avatar, isCheckListener) => {
    try {
        const room = await isRoomExists(roomId);

        if (room) {
            console.warn("Esta sala já existe");
            return;
        }

        saveRoom(roomId, identity, usuarioId, isRoomHost, avatar, isCheckListener);
    } catch (error) {
        console.error("Erro ao buscar sala:", error);
    }
};

export const removeRoom = async (roomId) => {
    try {
        const room = await isRoomExists(roomId);

        if (!room) {
            console.warn("Sala não encontrada");
            return;
        }

        const response = await apiCreate.delete(`${SERVER_API}/room-remove/${room._id}`);
        console.warn('Sala deletada:', response.data);
    } catch (error) {
        console.error("Erro ao remover sala:", error);
    }
};